import { Component, Input } from '@angular/core';
import { OmpHeadingSize } from '../../../_models';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-shipping-payment-settings',
  templateUrl: './shipping-payment-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpShippingPaymentSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  @Input() pageBackground = '';

  get previewBackground(): string {
    let background = this.pageBackground;
    if (this.data && this.data.display_inside_card && this.data.background_color) {
      background = this.data.background_color;
    }
    return background;
  }

}
